import { useContext } from 'react';
import { createUseSelectQueryData } from '../hooks/useSelectQueryData';
import { createUseSelectApolloQueryData } from '../hooks/useSelectApolloQueryData';
export const createQueryDataHooks = Context => {
  const useQueryDataContext = () => useContext(Context);
  const useSelectQueryData = createUseSelectQueryData(Context);
  const useSelectApolloQueryData = createUseSelectApolloQueryData(Context);
  return {
    useQueryDataContext,
    useSelectQueryData,
    useSelectApolloQueryData
  };
};